import React, { useState, useContext, useEffect } from "react";
import PhHeader from "../components/photographer/PhHeader";
import AppFooter from "../components/AppFooter";
import UserContext from "../contexts/UserContext";

import Utils from "./../Utils";

const PhLayout = ({ children }) => {
  const { userData } = useContext(UserContext);

  useEffect(() => {
    if (userData == null || userData == undefined || userData == false) {
      window.location.href = process.env.PUBLIC_URL + "/";
    }
  }, [userData]);

  return (
    <div className="ftbottom" style={{ backgroundColor: "#fcf0d8" }}>
      <div style={{ backgroundColor: "#f7daa0" }}>
        <PhHeader />
      </div>
      {children}
      <AppFooter />
    </div>
  );
};
export default PhLayout;
